import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Download } from 'lucide-react';
import useSeoMeta from '../hooks/useSeoMeta';
import seoPaginas from '../content/seoPaginas.json';
import PublicNav from '../components/common/PublicNav';
import PublicFooter from '../components/common/PublicFooter';
import { Eyebrow } from '../components/landing/brand';
import { RECURSOS } from '../content/recursos';

// /recursos: índice de las planillas Excel gratuitas (src/content/recursos.ts).

const RecursosPage: React.FC = () => {
  useSeoMeta(seoPaginas.recursos);

  return (
    <div className="lp">
      <PublicNav />

      <main>
        <section className="lp-ph">
          <div className="lp-wrap">
            <Eyebrow>Recursos gratis</Eyebrow>
            <h1>Planillas ganaderas en Excel gratis</h1>
            <p className="lp-lead" style={{ maxWidth: 760 }}>
              Planillas en Excel para llevar el registro de ganado, las existencias del campo y los lotes de feedlot. Se
              descargan gratis, sin registrarte, y vienen con las fórmulas armadas. Cuando quieras dejar el Excel, la
              planilla ganadera se importa tal cual a Mi Campo Digital.
            </p>
          </div>
        </section>

        <section className="lp-sec lp-sec--white">
          <div
            className="lp-wrap"
            style={{ display: 'grid', gap: 20, gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}
          >
            {RECURSOS.map((r) => (
              <article key={r.slug} className="lp-card lp-card--lift">
                <h2 className="lp-h3" style={{ fontSize: 22 }}>
                  <Link to={`/recursos/${r.slug}`}>{r.nombreCorto}</Link>
                </h2>
                <p className="lp-body">{r.resumen}</p>
                <p style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 12 }}>
                  <a className="lp-btn lp-btn--primary lp-btn--sm" href={r.archivo} download>
                    <Download aria-hidden="true" /> Descargar
                  </a>
                  <Link className="lp-link" to={`/recursos/${r.slug}`}>
                    Ver qué trae <ArrowRight aria-hidden="true" />
                  </Link>
                </p>
              </article>
            ))}
          </div>
        </section>
      </main>

      <PublicFooter />
    </div>
  );
};

export default RecursosPage;
